module.exports = __webpack_public_path__ + "img/arrow-up-right-square.c5bddcf8.svg";